module.exports = {"data":{"drupalMedia":{"image_desktop":{"url":"https://cms.attn.com/sites/default/files/2023-09/CAREERS-COVER-NEW.png"},"image_mobile":{"url":"https://cms.attn.com/sites/default/files/2023-09/CAREERS-COVER-NEW_0.png"}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/careers.json
// module id = 905
// module chunks = 114387730673500